import { render } from "./PromoCodes.vue?vue&type=template&id=c66bdac0&scoped=true"
import script from "./PromoCodes.vue?vue&type=script&lang=js"
export * from "./PromoCodes.vue?vue&type=script&lang=js"

import "./PromoCodes.vue?vue&type=style&index=0&id=c66bdac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66bdac0"]])

export default __exports__